module.exports = __webpack_public_path__ + "media/guide.d7c48cec.mp4";